export const requireErrorMessage = (fieldName: string): string =>
	`Missing ${fieldName}`;
